export default __webpack_public_path__ + "static/media/image.stephen-innovations-pvt-ltd.3ad0c9b0.png";